<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27"
    height="17"
    viewBox="0 -2 27 17"
    fill="none"
    class="-mt-0.5"
  >
    <path d="M-1 -2 L28 -2 L13.5 15 Z" fill="white" />
    <path
      d="M0 0 L13.5 15 L27 0"
      stroke="#64D7DC"
      stroke-width="2"
      fill="none"
      stroke-linejoin="round"
    />
  </svg>
</template>
